import React from 'react';
import {Popover, PopoverProps} from '@mui/material';

type BaseProps = Omit<PopoverProps, 'slotProps' | 'sx' | 'anchorOrigin' | 'transformOrigin'>;

const anchorOrigin = { vertical: 'bottom', horizontal: 'left' } as const;
const transformOrigin = { vertical: 'top', horizontal: 'left' } as const;

export const FilterPreviewPopover: React.FC<BaseProps> = (props) => {
    const { children, ...rest } = props;

    return (
        <Popover
            {...rest}
            slotProps={{
                paper: {
                    sx: {
                        bgcolor: 'var(--background-secondary-not-transparent)',
                        borderRadius: '8px',
                    }
                }
            }}
            sx={{
                pointerEvents: 'none',
                marginTop: '4px',
                '& .MuiPopover-paper': {
                    borderRadius: '8px',
                    maxWidth: '300px',
                    flexDirection: 'column',
                }
            }}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            hideBackdrop
            disableRestoreFocus
        >
            {children}
        </Popover>
    );
};

export const FilterPopover: React.FC<BaseProps> = (props) => {
    const { children, ...rest } = props;

    return (
        <Popover
            {...rest}
            slotProps={{
                paper: {
                    sx: {
                        bgcolor: 'var(--background-secondary-not-transparent)',
                        borderRadius: '8px',
                        minWidth: '300px',
                        maxWidth: '400px',
                        width: '400px',
                    }
                }
            }}
            sx={{
                marginTop: '4px',
            }}
            anchorOrigin={anchorOrigin}
        >
            {children}
        </Popover>
    );
};
